const ITEMS = ["THEYYAM", "RITUAL", "KANNUR", "HERITAGE", "DEVOTION", "CULTURE"];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-charcoal/10 bg-ivory py-5 select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((n) => (
          <div key={n} className="flex shrink-0 items-center">
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="mx-8 md:mx-12 text-xs md:text-sm uppercase tracking-[0.4em] text-charcoal/50 font-medium whitespace-nowrap">
                  {t}
                </span>
                <span className="text-gold text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
